import { toast } from "react-hot-toast";

export const SuccessToast = (text) => {
  toast.dismiss(); // Dismiss all existing toasts
  return toast.success(text, { // Use toast.success
    duration: 5000,
    style: {
      backgroundColor: "rgb(52, 207, 52)", // Specific color for success
      color: "white",
      height: "auto",
      paddingTop: "0px",
      paddingBottom: "0px",
    },
    iconTheme: {
      primary: "white",
      secondary: "rgb(52, 207, 52)",
    },
    action: {
      text: '×',
      ariaLabel: 'Close',
      onClick: (e, toastObject) => {
        toast.dismiss(toastObject.id);
        e.preventDefault();
      },
    },
  });
};

export const ErrorToast = (text) => {
  toast.dismiss(); // Dismiss all existing toasts
  return toast.error(text, { // Use toast.error
    duration: 3000,
    style: {
      backgroundColor: "red", // Specific color for error
      color: "white",
      height: "auto",
      paddingTop: "0px",
      paddingBottom: "0px",
    },
    iconTheme: {
      primary: "white",
      secondary: "red",
    },
    action: {
      text: '×',
      ariaLabel: 'Close',
      onClick: (e, toastObject) => {
        toast.dismiss(toastObject.id);
        e.preventDefault();
      },
    },
  });
};

export const WarningToast = (text) => {
  toast.dismiss(); // Dismiss all existing toasts
  return toast(text, { // Use toast for general messages
    duration: 5000,
    style: {
      backgroundColor: "orange", // Specific color for warning
      color: "white",
      height: "auto",
      paddingTop: "0px",
      paddingBottom: "0px",
    },
    iconTheme: {
      primary: "white",
      secondary: "orange",
    },
    action: {
      text: '×',
      ariaLabel: 'Close',
      onClick: (e, toastObject) => {
        toast.dismiss(toastObject.id);
        e.preventDefault();
      },
    },
  });
};

export const PromiseToast = (promiseFun, options) => {
  toast.dismiss(); // Dismiss all existing toasts
  return toast.promise(
    promiseFun(),
    {
      loading: options.loading || "Loading...",
      success: options.success || <b>Action successful!</b>,
      error: options.error || <b>Action failed.</b>,
    },
    {
      duration: 5000,
      action: {
        text: '×',
        ariaLabel: 'Close',
        onClick: (e, toastObject) => {
          toast.dismiss(toastObject.id);
          e.preventDefault();
        },
      },
    }
  );
};
